export const LIQUIDEZ_SEM_DADO_LABEL = 'Sem dados'

export const LIQUIDEZ_BUCKETS = [
  { label: 'Até 1 dia', min: 0, max: 1 },
  { label: 'De 2 até 35 dias', min: 2, max: 35 },
  { label: 'De 36 até 180 dias', min: 36, max: 180 },
  { label: 'De 181 até 360 dias', min: 181, max: 360 },
  { label: 'Acima de 360 dias', min: 361, max: Infinity },
]
